module.exports = __webpack_public_path__ + "static/media/ryan.f217f346.jpg";